import axios from '../../axios'

export const login = (email, password) => {
  return axios.post(process.env.AUTH_URL, {email, password})
}



// WEBPACK FOOTER //
// ./src/api/production/auth/index.js